import { Component, inject } from '@angular/core';
import { ValidarSolicitudService } from './validarSolicitud.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { paramsValidarInterface, postValidarCorreoInterface } from './validarSolicitud.interface';
import { BaseReponseGeneric } from '../../../commons/class/BaseReponseGeneric.interface';
import { ConfirmationDialogService } from '../../../commons/components/confirm-dialog/confirm-dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IpService } from '../../../commons/services/ipService.service';

@Component({
    selector: 'oaj-validar-solicitud-autoenrolamiento-itx',
    templateUrl: 'validarSolicitud.component.html',
    styleUrls: ['./validarSolicitud.component.css'],
    providers: [ValidarSolicitudService, ConfirmationDialogService],
    imports: []
})

export class ValidarSolicitudComponent {
    private service: ValidarSolicitudService = inject(ValidarSolicitudService);
    private router: Router = inject(Router);
    private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
    private routeParams: ActivatedRoute = inject(ActivatedRoute);
    private ipService = inject(IpService);
    private ip = '';

    paramsC: paramsValidarInterface;

    constructor() {
        this.paramsC = { _guid: '' };

        this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
                this.routeParams.queryParams.subscribe((x: Params) => {
                    if (x) {
                        this.paramsC = { _guid: x['_guid'] }

                        if (this.paramsC._guid.length > 0) {
                            //actualizar registro
                            const post: postValidarCorreoInterface = { Guid: this.paramsC._guid, sIP: this.ip };
                            this.service.actualizarGuid(post).subscribe((respuesta: BaseReponseGeneric<boolean>) => {
                                if (respuesta && respuesta.succcess) {
                                    this.modalConfirmacionService.confirm('Verificación de solicitud', 'La solicitud se encuentra en proceso de verificación por parte de la Dirección General de Gestión Judicial, en breve recibirá correo electrónico en esta misma cuenta con el resultado.', 'Aceptar', '')
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars   
                                        .then(confirm => {
                                            //if(confirm){}
                                            this.router.navigateByUrl('/login');
                                        })
                                }
                                else {
                                    this.modalConfirmacionService.confirm('Validación correo', respuesta.message, 'Aceptar')
                                }
                            }, (error: HttpErrorResponse) => {
                                //console.log('error', error.error.message);
                                this.modalConfirmacionService.confirm('Validación correo', error.error.message, 'Aceptar', '')
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars    
                                    .then(confirm => {
                                        //if(confirm){}
                                        this.router.navigateByUrl('/login');
                                    })
                            });
                        }
                    }
                });
            }
        );
    }


}